import { Price } from './price';
import { Sector } from './sector';

export interface FlightValidationRequest {
  searchId: string;
  sessionToken: string;
  optionId: number;
  upsellOptionId: number;
  userId: string;
  distanceRestriction: string;
  lowestLogicalFare: number;
}

export interface AirFareConditions {
  id: number;
  //  airReservationId?: number;
  airReservationsId?: number;
  sector: number;
  flight: string;
  cancellationAllowed: boolean;
  cancellationAllowedAfter: boolean;
  changesAllowed: boolean;
  changesAllowedAfter: boolean;
  noShow: number;
  changesAmount?: {
    currencyCode: string;
    fare: number;
    taxes: number;
  };
  changesAmountAfter?: {
    currencyCode: string;
    fare: number;
    taxes: number;
  };
  cancellationAmount?: {
    currencyCode: string;
    fare: number;
    taxes: number;
  };
  cancellationAmountAfter?: {
    currencyCode: string;
    fare: number;
    taxes: number;
  };
}

export enum AirValidationResultType {
  Available = 'Available',
  NotAvailable = 'NotAvailable',
  PriceDifferent = 'PriceDifference',
  ErrorServer = 'ErrorServer',
}

export interface FlightValidationResponse {
  tripOption: {
    sectors: Sector[];
    price: Price;
    alternativePrice?: Price;
    provider: string;
    adultsFareAmount: number;
    childsFareAmount: number;
    infantsFareAmount: number;
    preferenceOrder: number;
    textFare: string;
    optionId: number;
    hasPrivateFare?: boolean;
  };
  result: AirValidationResultType;
  airFareConditions: AirFareConditions[];
  validateAvailableUntil: Date;
  validationId: string;
  isPreApproved?: boolean;
  breakRulesMessage?: string[];
  airValidateResponse: AirValidateResponse[]; // bysector
  totalPrice: TotalPrice; // bysector
}


export interface FlightValidationResponseBySector {
  validDocuments: ValidDocument[];
  airValidateResponse: AirValidateResponse[];
  totalPrice: TotalPrice;
  alternativeTotalPrice?: TotalPrice;
  isPreApproved: boolean;
  breakRulesMessage: any[];
  validationIds: string[];
}

export interface ValidDocument {
  id: number
  name: string
  documentId: number
  regex?: string
}

export interface AirValidateResponse {
  tripOption: TripOption
  result: string
  airFareConditions: AirFareCondition[]
  validateAvailableUntil: string
  validationId: string
  isPreApproved: boolean
}

export interface TotalPrice {
  taxes: number
  totalDuePayment: number
  total: number
  amount: number
  fees: number
  surcharges: number
  discountAmount: number
  commissionAmount: number
  commissionPercentage: number
  penaltyAmount: number
  currencyCode: string
}

export interface TripOption {
  sectors: Sector[];
  price: Price;
  alternativePrice?: Price;
  provider: string;
  adultsFareAmount: number;
  childsFareAmount: number;
  infantsFareAmount: number;
  preferenceOrder: number;
  textFare: string;
  optionId: number;
  hasPrivateFare?: boolean;
}

export interface AirFareCondition {
  id: number;
  airReservationsId: number;
  sector: number;
  flight: string;
  cancellationAllowed: boolean;
  changesAllowed: boolean;
  changesAmount: ChangesAmount;
  changesAmountAfter: ChangesAmount;
  cancellationAmount: ChangesAmount;
  cancellationAmountAfter: ChangesAmount;
  noShow: number;
  noShowAfter: number;
  cancellationAllowedAfter: boolean;
  changesAllowedAfter: boolean;
}

export interface ChangesAmount {
  currencyCode: string
  fare: number
  taxes: number
  alternativeFare: number
  alternativeTaxes: number
}